import React, { Component } from "react";
import $, { type } from "jquery";
import moment from "moment";
import SuggestionList from "./SuggestionList";
import StandardSelectModal from "./StandardSelectModal";
import ApiClient from "../libs/apiClient";
import WarningModal from "./WarningModal";
let apiClient = ApiClient.getInstance();

const formatNumber = (num, simbol) => {
    if (isNaN(num)) return num;
    if (typeof (simbol) !== "string") simbol = "";
    num = Number(num).toFixed(2);
    const separador = ','; // separador para los miles
    const sepDecimal = '.'; // separador para los decimales
    num += '';
    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) { splitLeft = splitLeft.replace(regx, "$1" + separador + "$2"); }
    return simbol + splitLeft + splitRight;
}

const docType = (field = "") => {
    switch (Number(field)) {
        case 13: return "Factura de deudores";
        case 14: return "Nota de crédito";
        case 24: return "Saldo a favor";
        case 203: return "Factura de anticipó";
        default: return "Documento desconocido";
    }
}

const formatDate = (value = "") => {
    const date = moment(value);
    if (date.isValid()) return date.format("DD/MM/YYYY");
    else return "--/--/----"
}
const headers = [
    { title: "Documento", value: true, filter: true, field: "ObjType", format: docType, classes: "text-left" },
    { title: "N° Doc", value: true, filter: true, field: "DocNum", format: null, classes: "text-left" },
    { title: "F. Contabilización", value: true, filter: true, field: "TaxDate", format: formatDate, classes: "text-left" },
    { title: "Importe", value: true, filter: true, field: "DocTotal", format: formatNumber, classes: "text-right" },
    { title: "Saldo Vencido", value: true, filter: true, field: "Remaining", format: formatNumber, classes: "text-right" },
];

class ReconciliationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CardCode: "",
            CardName: "",
            DocDate: moment().format("YYYY-MM-DD"),
            DocTotal: "0.00",
            Invoices: [],
            showSelectPartnerModal: false,
            predictionClient: [],
            showClientPredictions: false,
            indexCardCode: -1,
            showWarningModal: false,
        }
    }

    componentDidMount() {
        const { Bonus, DefaultSelection } = this.props;
        this.setState({ bonus: Number(Bonus).toFixed(2), selectionList: DefaultSelection || [], });
    }

    close = () => {
        $("#ReconciliationModal").modal("hide");
    };

    predictClient = async (value = "") => {
        const { clientList } = this.props;
        let predictionClient = [];
        value = value.toLowerCase();
        if (value) {
            let searchTokens = value.split(" ");
            predictionClient = clientList.filter(record => {
                let tokens = (record?.CardCode + " " + record?.CardName).toLowerCase().split(" ");
                let match = searchTokens.every((token) => tokens.some((itemToken) => itemToken.includes(token)));
                return match;
            }).slice(0, 30).map(record => { return { value1: record.CardCode, value2: record.CardName }; });
        }
        await this.setState({ CardCode: value, CardName: "", Invoices: [], predictionClient, showClientPredictions: predictionClient.length, indexCardCode: -1 });
        this.updateSuggestionsPosition();
    }

    CardCodeInteractions = (event = null) => {
        const { predictionClient } = this.state;
        let { indexCardCode, CardCode } = this.state;

        switch (event?.key) {
            case "Enter":
                if (indexCardCode < 0) {
                    if (predictionClient.length === 1) { this.searchClient(predictionClient[0].value1) }
                    else { this.searchClient(CardCode); }
                } else { this.searchClient(predictionClient[indexCardCode].value1); }
                break;
            case "ArrowUp":
                if (predictionClient?.length && indexCardCode > -1) { indexCardCode--; }
                this.setState({ indexCardCode });
                break;
            case "ArrowDown":
                if (predictionClient?.length && indexCardCode < (predictionClient?.length || 0) - 1) { indexCardCode++; }
                this.setState({ indexCardCode });
                break;
            case "Tab":
                if (indexCardCode !== -1 && predictionClient?.length) {
                    this.searchClient(predictionClient[indexCardCode].value1)
                    event.preventDefault();
                } else if (predictionClient?.length === 1) {
                    this.searchClient(predictionClient[0].value1)
                    event.preventDefault();
                }
                break;
            default: break;
        }
    }

    updateSuggestionsPosition = () => {
        const modalElement = document.getElementById('modalContent');
        const inputFieldClient = document.getElementById('txtReconciliationCardCode');
        const suggestionsListClient = document.getElementById('suggestionListClient');

        if (!!inputFieldClient && !!suggestionsListClient) {
            if (!!modalElement) {
                const inputRect = inputFieldClient.getBoundingClientRect();
                const modalReact = modalElement.getBoundingClientRect();

                suggestionsListClient.style.top = `${inputRect.top - modalReact.top - inputRect.height - 36}px`;
                suggestionsListClient.style.left = `${inputRect.left - modalReact.left}px`;
            } else if (!!suggestionsListClient) {
                suggestionsListClient.style.top = `calc(60%)`;
                suggestionsListClient.style.left = `calc(25%)`;
            }
        }

    };

    openSelectPartnerModal = async () => {
        await this.setState({ showSelectPartnerModal: true });
        $("#selectPartnerModal").modal("show");
    }

    searchClient = async (option) => {
        const { enableSpinner, showAlert } = this.props;
        const CardCode = option.CardCode || option || "";
        $("#selectPartnerModal").modal("hide");
        await this.setState({ CardCode, predictionClient: [], showClientPredictions: false, indexCardCode: -1 });

        enableSpinner(true);
        let invoicesResponse = await apiClient.getReconciliationInvoices(CardCode);
        enableSpinner(false);

        if (!invoicesResponse.status) return showAlert({ type: "info", message: invoicesResponse?.message || "Ocurrió un error desconocido, vuelva a intentarlo más tarde" });
        await this.setState({
            CardName: invoicesResponse?.data?.CardName || "",
            Invoices: invoicesResponse?.data?.Invoices || [],
        });
    }

    selectElement = (index) => {
        let { Invoices } = this.state;
        const value = !Invoices[index].Selected;
        if (value) return this.validateAmount(index);
        Invoices[index].Selected = value;
        this.setState({ Invoices });
        this.refreshTotal();
    }

    changeAmount = (index, value) => {
        if (value.trim() === ".") value = "0.";
        if (isNaN(value.replace(/\(/g, '').replace(/\)/g, '').replace(/,/g, '').replace(/-/g, ''))) return;
        let { Invoices } = this.state;
        Invoices[index].Amount = value;
        this.setState({ Invoices });
        this.refreshTotal();
    }

    validateAmount = (index) => {
        const { showAlert } = this.props;
        let { Invoices } = this.state;
        let invoice = Invoices[index];
        let value = (invoice.Amount || "0.00").replace(/\(/g, '').replace(/\)/g, '').replace(/,/g, '');
        let valid = false;

        if (isNaN(value)) value = "0.00";
        value = Number(value);

        if (Number(invoice.Remaining) > 0) valid = value > 0 && value <= Number(invoice.Remaining);
        else valid = value < 0 && value >= Number(invoice.Remaining);

        if (!valid) showAlert({ type: "warning", message: "Ingrese un valor valido entre 0 y Saldo Vencido" });

        value = formatNumber(value);
        Invoices[index].Selected = valid;
        Invoices[index].Amount = value;
        this.setState({ Invoices });
        this.refreshTotal();
    }

    refreshTotal = () => {
        const selectedDocs = this.state.Invoices.filter(({ Selected }) => Selected);
        let DocTotal = 0;

        for (const doc of selectedDocs) {
            let amount = (doc.Amount || "0.00").replace(/\(/g, '').replace(/\)/g, '').replace(/,/g, '');
            if (isNaN(amount)) amount = "0.00";
            amount = Number(amount);
            if (Number(doc.ObjType) === 24) amount = amount * -1;
            DocTotal += amount;
        }
        DocTotal = formatNumber(DocTotal);
        this.setState({ DocTotal });
    }

    validateDocument = async () => {
        await this.refreshTotal();
        const { CardName, DocDate, DocTotal, Invoices } = this.state;
        const { showAlert } = this.props;
        const selectedDocs = Invoices.filter(({ Selected }) => Selected);

        if (!CardName) return showAlert({ type: "warning", message: "Seleccione un socio de negocio" });
        if (!moment(DocDate).isValid()) return showAlert({ type: "warning", message: "Ingrese una fecha valida" });
        if (!selectedDocs.length) return showAlert({ type: "warning", message: "Seleccione documentos para reconciliar" });
        if (Number(DocTotal)) return showAlert({ type: "warning", message: "El total de la reconciliación debe ser cero para continuar" });
        this.openCloseWarningModal(true);
    }

    openCloseWarningModal = async (status) => {
        await this.setState({ showWarningModal: status });
        if (status) { $('#warningModal').modal('show'); }
        else { $('#warningModal').modal('hide'); }
    }

    createDocument = async () => {
        await this.refreshTotal();
        const { enableSpinner, showAlert } = this.props;
        const { CardCode, DocDate, Invoices } = this.state;
        const selectedDocs = Invoices.filter(({ Selected }) => Selected);
        const model = {
            ReconDate: moment(DocDate).format("YYYY-MM-DD"),
            CardOrAccount: "C",
            InternalReconciliationOpenTransRows: []
        }
        for (const doc of selectedDocs) {
            model.InternalReconciliationOpenTransRows.push({
                Selected: "tYES",
                ShortName: CardCode,
                TransId: doc.TransId || 0,
                TransRowId: doc.TransRowId || 0,
                SrcObjTyp: doc.ObjType || 0,
                SrcObjAbs: doc.DocEntry || 0,
                CreditOrDebit: Number(doc.ObjType || 0) === 24 ? "codCredit" : "codDebit",
                ReconcileAmount: Number((doc.Amount || "0.00").replace(/\(/g, '').replace(/\)/g, '').replace(/,/g, '')),
                CashDiscount: 0.0
            });
        }
        enableSpinner(true);
        let reconciliationResponse = await apiClient.createReconciliation({ model });
        enableSpinner(false);

        if (!reconciliationResponse?.status) showAlert({ type: "error", message: reconciliationResponse?.message || "Ocurrió un error inesperado, vuelva a internatlo en unos minutos" });
        else {
            showAlert({ type: "success", message: "Transacciones reconciliadas" });
            this.searchClient(CardCode);
        }
    }

    render() {
        const { CardCode, CardName, Invoices, DocDate, DocTotal, predictionClient, showClientPredictions, indexCardCode, showSelectPartnerModal } = this.state;
        const { clientList } = this.props;

        return (
            <div>
                <div className="modal fade bd-example-modal-xl modal-open scroll" role="dialog" id="ReconciliationModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl modal-open" role="document">
                        <div className="modal-content" id="modalContent">

                            <div className="modal-header text-white" style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                                <h4 className="modal-title" id="modal-basic-title "> Reconciliación Interna </h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3 mr-3">
                                                <div className="input-group-prepend">
                                                    <label htmlFor="txtReconciliationCardCode" className="input-group-text font-weight-bold"> Cliente </label>
                                                </div>
                                                <input
                                                    id="txtReconciliationCardCode"
                                                    className="form-control"
                                                    value={CardCode}
                                                    onKeyDown={(ev) => this.CardCodeInteractions(ev)}
                                                    onChange={({ target: { value } }) => this.predictClient(value)} />
                                                <div className="input-group-prepend">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning rounded-right"
                                                        onClick={this.openSelectPartnerModal}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3 mr-3">
                                                <div className="input-group-prepend">
                                                    <label htmlFor="txtCurrency" className="input-group-text font-weight-bold"> Moneda </label>
                                                </div>
                                                <input
                                                    id="txtCurrency"
                                                    className="form-control"
                                                    readOnly
                                                    value="Peso Méxicano" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3 mr-3">
                                                <div className="input-group-prepend">
                                                    <label htmlFor="txtCardName" className="input-group-text font-weight-bold"> Nombre </label>
                                                </div>
                                                <input
                                                    id="txtCardName"
                                                    className="form-control"
                                                    readOnly
                                                    value={CardName} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3 mr-3">
                                                <div className="input-group-prepend">
                                                    <label htmlFor="txtDate" className="input-group-text font-weight-bold"> Fecha </label>
                                                </div>
                                                <input
                                                    disabled={true}
                                                    id="txtDate"
                                                    type="date"
                                                    className="form-control text-right"
                                                    value={DocDate}
                                                    onChange={() => { }} />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="w-100 table-scroll" style={{ minHeight: 300, maxHeight: 500 }}>
                                                <table className="table">
                                                    <thead className="table-header ">
                                                        <tr>
                                                            <td style={{ textAlign: "center" }} className="table-header-yellow" />
                                                            {headers.map(column => <td className="table-header-yellow" style={column.styles || {}} key={`col-Title-${column.field}`}>{column.title || ''}</td>)}
                                                            <td style={{ textAlign: "center" }} className="table-header-yellow"> Saldo a renconciliar </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Invoices.map((register, index) =>
                                                            <tr key={index}>
                                                                <td style={{ textAlign: "center" }} className={index % 2 === 0 ? 'dt-row-primary' : 'dt-row-secondary'} key={`col-Select-${index}`}>
                                                                    <input
                                                                        id={`chSelect-${index}`}
                                                                        type="checkbox"
                                                                        checked={register.Selected}
                                                                        onChange={() => this.selectElement(index)} />
                                                                </td>
                                                                {headers.map(column => <td className={`${column.classes || ''} ${index % 2 === 0 ? 'dt-row-primary-light' : 'dt-row-secondary-light'}`} style={column.styles || {}} key={`col-${column.field}-${index}`}>{column.format ? column.format(register[column.field] || '', register) : register[column.field] || ''}</td>)}

                                                                <td style={{ textAlign: "center" }} className={index % 2 === 0 ? 'dt-row-primary' : 'dt-row-secondary'} key={`col-Amount-${index}`}>
                                                                    <input
                                                                        id={`txtAmount-${index}`}
                                                                        className="form-control text-right"
                                                                        value={register.Amount}
                                                                        onChange={({ target: { value } }) => this.changeAmount(index, value)}
                                                                        onBlur={() => this.validateAmount(index)} />
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="col-0 col-lg-6" />
                                        <div className="col-12 col-lg-6">
                                            <div className="input-group mb-3 mr-3">
                                                <div className="input-group-prepend">
                                                    <label htmlFor="txtDocTotal" className="input-group-text font-weight-bold"> Total </label>
                                                </div>
                                                <input
                                                    id="txtDocTotal"
                                                    className="form-control text-right"
                                                    readOnly
                                                    value={DocTotal} />
                                            </div>
                                        </div>

                                        <SuggestionList
                                            idList="suggestionListClient"
                                            className="custom-optionsClient mt-5"
                                            listClassName="clientList-item"
                                            showOptions={showClientPredictions}
                                            predictions={predictionClient}
                                            selectedIndex={indexCardCode}
                                            onClickAction={this.searchClient}
                                            keyValue="value1" />
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCorrect text-white" onClick={this.validateDocument}> Reconciliar </button>
                                <button type="button" className="btn botonCerrar text-white" onClick={this.close}> Cerrar </button>
                            </div>
                        </div>
                    </div>
                </div>
                {showSelectPartnerModal &&
                    <StandardSelectModal
                        id="selectPartnerModal"
                        title="Socio de Negocio"
                        data={Array.isArray(clientList) ? clientList : []}
                        selectAction={this.searchClient}
                        headers={[
                            { title: "Cliente", value: true, filter: true, field: "CardCode", format: null, classes: "text-left" },
                            { title: "Nombre", value: true, filter: true, field: "CardName", format: null, classes: "text-left" },
                        ]}
                        actPos="start" />
                }
                {
                    <WarningModal
                        title='Advertencia'
                        message='¿Desea reconciliar las transacciones seleccionadas?'
                        btnAccept='Continuar'
                        btnCancel='Cancelar'
                        size='modal-md'
                        accept={this.createDocument}
                        cancel={() => this.openCloseWarningModal(false)} />
                }
            </div>
        );
    }
}

export default ReconciliationModal;